export const FIRST_LOAD_CATALOG_CAROUSEL_SKELETON = 6;
export const FIRST_LOAD_CHECKOUT_SKELETON = 4;
export const FIRST_LOAD_SHOPPING_CART_SKELETON = 3;
export const FIRST_LOAD_CATALOG_LIST_SKELETON = 15;
export const LOAD_MORE_CATALOG_LIST = 15;
